onReady(() => {
    const contentBanners = Array.from(document.querySelectorAll('.content-banner'))
    for (const contentBanner of contentBanners) {
        const ctaButton = contentBanner.querySelector('.cta-button')
        if (ctaButton) {
            ctaButton.addEventListener('click', (event) => dataLayer.push({
                event: 'cta-click',
                interactionType: 'click',
                moduleName: contentBanner.dataset.moduleName,
                elementContent: ctaButton.textContent.replace("\n", '')
                    .trim(),
                elementType: event.target.nodeName,
                elementClasses: event.target.classList.toString(),
                destinationUrl: event.target.href,
                modulePosition: contentBanner.dataset.modulePosition,
                distinctModulePosition: contentBanner.dataset.distinctModulePosition,
                moduleTabPosition: contentBanner.dataset.tabPosition,
                moduleId: contentBanner.dataset.moduleId,
                wpLoggedIn: document.body.classList.contains('logged-in')
                    .toString(),
            }))
        }
    }
})
